export default {
  'viewStopPayments.view': 'Stop Payment Request',
  'viewStopPayments.accountDetails': 'Account Details',
  'viewStopPayments.requestType': 'STP'
};
